module.exports = __webpack_public_path__ + "img/icon-white-62.eb4de82f.svg";